import Methods from "../methods";

const getMateriales = (context, payload) => {
  const url = `socio/materiales/${payload.idClient}/${payload.idAddress}`;
  return Methods.doGet(context, url, null);
};

const getItemMateriales = (context, payload) => {
  const url = `socio/itemmaterial/${payload.idClient}/${payload.idMaterial}?${payload.param}`;
  return Methods.doGet(context, url, null);
};

const getItemMaterialesBandejaDigitlaizacion = (context, payload) => {
  const url = `digitalizacion/itemmaterial/${payload.idClient}?${payload.param}`;
  return Methods.doGet(context, url, null);
};

const saveItemMaterial = (context, payload) => {
  const url = `/socio/materiales/${payload.idClient}`;
  return Methods.doPost(context, url, payload.itemMaterial);
};

const deleteItemMaterial = (context, payload) => {
  const url = `socio/materiales/${payload.idItemMaterial}`;
  return Methods.doDelete(context, url, null);
};

const importItemMaterialMasivo = (context, payload) => {
  const url = `/socio/imports/${payload.idClient}/${payload.idMaterial}`;

  var data = new FormData();
  data.append("file", payload.file);
  data.append("idOrderMaterial", payload.idOrderMaterial);
  data.append("code", payload.code);
  return Methods.doPost(context, url, data);
};

const enviarBandejaDigitalizacion = (context, payload) => {
  const url = `/socio/enviarBandejaDigitalizacion/${payload.idClient}/${payload.idMaterial}`;

  return Methods.doGet(context, url, null);
};

const actualizarItemMaterialEstado = (context, payload) => {
  const url = `/digitalizacion/actualizar`;
  return Methods.doPut(context, url, payload.itemMaterial);
};

const eliminarTodosRegistros = (context, payload) => {
  const url = `socio/materiales/${payload.idItemMaterial}/${payload.idClient}`;
  return Methods.doDelete(context, url, null);
};

const getitemmaterialBycode = (context, payload) => {
  const url = `digitalizacion/itemmaterialBycode/${payload.idClient}?${payload.param}`;
  return Methods.doGet(context, url, null);
};


export default {
  getMateriales,
  getItemMateriales,
  saveItemMaterial,
  deleteItemMaterial,
  importItemMaterialMasivo,
  enviarBandejaDigitalizacion,
  getItemMaterialesBandejaDigitlaizacion,
  actualizarItemMaterialEstado,
  eliminarTodosRegistros,
  getitemmaterialBycode
};



// WEBPACK FOOTER //
// ./src/api/modules/SociosApi.js